exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".titleContainer {\n  padding-bottom: 10px;\n  color: #4b81b0;\n  text-align: left; }\n\n.errorIcon {\n  font-size: 90px;\n  margin-bottom: 15px;\n  color: #c5c5c5;\n  text-align: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/negocios/tablero-negocios/expanded-chart-dialog/expanded-chart-dialog.component.scss
// module id = ../../../../../src/app/components/negocios/tablero-negocios/expanded-chart-dialog/expanded-chart-dialog.component.scss
// module chunks = 0